module.exports = __webpack_public_path__ + "static/about-content-3-d7e1e9ad23b859c707f7fd7a39b967af.png";